

@if (showContent) {
    <ng-content></ng-content>
} @else {
    <skl-spinner
        class="dialog-content-spinner"
        [size]="200"
        [invert]="false">
    </skl-spinner>
}